'use client';

import { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Mercado', href: '#mercado' },
    { label: 'Estratégias', href: '#estrategias' },
    { label: 'Curitiba', href: '#curitiba' },
    { label: 'Investidores', href: '#investidores' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? 'py-3 bg-bg/90 backdrop-blur-md border-b border-fg/5' :'py-5 bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          {/* Logo */}
          <a href="#" aria-label="VS Cardoso Studios Home">
            <AppLogo
              className=""
            />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8 text-[11px] font-medium uppercase tracking-[0.18em]">
            {navLinks?.map((link) => (
              <a
                key={link?.href}
                href={link?.href}
                className="text-fg/60 hover:text-fg transition-colors duration-200"
              >
                {link?.label}
              </a>
            ))}
            <a
              href="/imoveis"
              className="text-fg/60 hover:text-accent transition-colors duration-200"
            >
              Imóveis
            </a>
            <a
              href="#contato"
              className="px-6 py-2.5 bg-accent text-bg font-semibold rounded-sm text-[11px] uppercase tracking-widest hover:bg-accent-light transition-colors duration-200"
            >
              Fale com Especialista
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden text-fg p-2 -mr-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              {menuOpen ? (
                <>
                  <path d="M18 6L6 18" /><path d="M6 6l12 12" />
                </>
              ) : (
                <>
                  <path d="M4 6h16" /><path d="M4 12h16" /><path d="M4 18h16" />
                </>
              )}
            </svg>
          </button>
        </div>
      </nav>
      {/* Mobile Menu */}
      <div
        id="mobile-menu"
        className={`fixed inset-0 bg-bg z-40 flex flex-col justify-center items-center gap-8 transition-transform duration-500 ${
          menuOpen ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        {navLinks?.map((link) => (
          <a
            key={link?.href}
            href={link?.href}
            onClick={() => setMenuOpen(false)}
            className="font-display text-4xl text-fg/80 hover:text-accent transition-colors italic"
          >
            {link?.label}
          </a>
        ))}
        <a
          href="/imoveis"
          onClick={() => setMenuOpen(false)}
          className="font-display text-4xl text-fg/80 hover:text-accent transition-colors italic"
        >
          Imóveis
        </a>
        <a
          href="#contato"
          onClick={() => setMenuOpen(false)}
          className="mt-4 px-10 py-4 bg-accent text-bg font-semibold text-sm uppercase tracking-widest rounded-sm"
        >
          Fale com Especialista
        </a>
      </div>
    </>
  );
}